var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "registration-form-container" }, [
    _c("div", { staticClass: "registration-form-title" }, [
      _c(
        "button",
        {
          on: {
            click: function($event) {
              return _vm.redirectTo("/", "stretch")
            }
          }
        },
        [
          _c("img", {
            attrs: {
              src: require("@/common/assets/images/icon-left.webp"),
              alt: "back"
            }
          })
        ]
      ),
      _c("h2", [_vm._v("Request a Guest Account")])
    ]),
    _c(
      "form",
      {
        staticClass: "registration-form",
        on: { submit: event => _vm.handleSubmit(event) }
      },
      [
        _c("div", { staticClass: "register-form-content" }, [
          _c("label", { attrs: { for: "email" } }, [_vm._v("Email:")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.username,
                expression: "formData.username"
              }
            ],
            class: [
              { "error-border": !_vm.FORM_VALIDATOR?.isFieldValid("username") }
            ],
            attrs: {
              type: "email",
              id: "email",
              name: "email",
              placeholder: "Enter your email",
              required: "",
              autocomplete: "email"
            },
            domProps: { value: _vm.formData.username },
            on: {
              focusout: function($event) {
                _vm.FORM_VALIDATOR?.validateFormField("username")
              },
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "username", $event.target.value)
              }
            }
          })
        ]),
        _c("div", { staticClass: "register-form-content" }, [
          _c("label", { attrs: { for: "fullName" } }, [_vm._v("Full Name:")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.fullName,
                expression: "formData.fullName"
              }
            ],
            class: [
              { "error-border": !_vm.FORM_VALIDATOR?.isFieldValid("fullName") }
            ],
            attrs: {
              type: "text",
              id: "fullName",
              name: "fullName",
              placeholder: "Enter your full name",
              required: "",
              autocomplete: "fullName"
            },
            domProps: { value: _vm.formData.fullName },
            on: {
              focusout: function($event) {
                _vm.FORM_VALIDATOR?.validateFormField("fullName")
              },
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "fullName", $event.target.value)
              }
            }
          })
        ]),
        _c("div", { staticClass: "register-form-content" }, [
          _c("label", { attrs: { for: "password" } }, [_vm._v("Password:")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.password,
                expression: "formData.password"
              }
            ],
            class: [
              { "error-border": !_vm.FORM_VALIDATOR?.isFieldValid("password") }
            ],
            attrs: {
              type: "password",
              id: "password",
              name: "password",
              placeholder: "Enter your password",
              required: "",
              autocomplete: "password"
            },
            domProps: { value: _vm.formData.password },
            on: {
              focusout: function($event) {
                _vm.FORM_VALIDATOR?.validateFormField("password")
              },
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "password", $event.target.value)
              }
            }
          }),
          _c(
            "span",
            {
              staticClass: "toggle-password",
              on: {
                click: function($event) {
                  return _vm.togglePasswordVisibility("password")
                }
              }
            },
            [_c("img", { attrs: { src: _vm.visible, alt: "eye" } })]
          )
        ]),
        _c("div", { staticClass: "register-form-content" }, [
          _c("label", { attrs: { for: "confirmPassword" } }, [
            _vm._v("Confirm Password:")
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.confirmPassword,
                expression: "formData.confirmPassword"
              }
            ],
            class: [
              {
                "error-border": !_vm.FORM_VALIDATOR?.isFieldValid(
                  "confirmPassword"
                )
              }
            ],
            attrs: {
              type: "password",
              id: "confirmPassword",
              name: "confirmPassword",
              placeholder: "Confirm your password",
              required: "",
              autocomplete: "confirmPassword"
            },
            domProps: { value: _vm.formData.confirmPassword },
            on: {
              focusout: function($event) {
                _vm.FORM_VALIDATOR?.validateFormField("confirmPassword")
              },
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "confirmPassword", $event.target.value)
              }
            }
          }),
          _c(
            "span",
            {
              staticClass: "toggle-password",
              on: {
                click: function($event) {
                  return _vm.togglePasswordVisibility("confirmPassword")
                }
              }
            },
            [_c("img", { attrs: { src: _vm.visible, alt: "eye" } })]
          )
        ]),
        _c("div", { staticClass: "register-form-content" }, [
          _c("label", { attrs: { for: "company" } }, [_vm._v("Company:")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.company,
                expression: "formData.company"
              }
            ],
            class: [
              { "error-border": !_vm.FORM_VALIDATOR?.isFieldValid("company") }
            ],
            attrs: {
              type: "text",
              id: "company",
              name: "company",
              placeholder: "Enter your company name",
              required: "",
              autocomplete: "company"
            },
            domProps: { value: _vm.formData.company },
            on: {
              focusout: function($event) {
                _vm.FORM_VALIDATOR?.validateFormField("company")
              },
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "company", $event.target.value)
              }
            }
          })
        ]),
        _c("div", { staticClass: "register-form-content" }, [
          _c("label", { attrs: { for: "jobTitle" } }, [_vm._v("Job Title:")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.jobTitle,
                expression: "formData.jobTitle"
              }
            ],
            class: [
              { "error-border": !_vm.FORM_VALIDATOR?.isFieldValid("jobTitle") }
            ],
            attrs: {
              type: "text",
              id: "jobTitle",
              name: "jobTitle",
              placeholder: "Enter your job title",
              required: "",
              autocomplete: "jobTitle"
            },
            domProps: { value: _vm.formData.jobTitle },
            on: {
              focusout: function($event) {
                _vm.FORM_VALIDATOR?.validateFormField("jobTitle")
              },
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "jobTitle", $event.target.value)
              }
            }
          })
        ]),
        _c(
          "div",
          { staticClass: "form-bottom" },
          [
            _vm._l(_vm.FORM_VALIDATOR?.errors(), function(error, index) {
              return _c("span", { key: index, staticClass: "error" }, [
                _vm._v(_vm._s(error.fieldCondition.message))
              ])
            }),
            _c("input", {
              class: [
                "apply-button",
                {
                  "not-allowed":
                    !_vm.FORM_VALIDATOR?.isFormValid() ||
                    !this.allFieldsAreFilled()
                }
              ],
              attrs: { type: "submit", value: "Apply" }
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }